import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AssetUIModel } from '@thehubz/client/core';

@Component({
  selector: 'thehubz-asset-dashboard-card-view',
  templateUrl: './asset-dashboard-card-view.component.html',
  styleUrls: ['./asset-dashboard-card-view.component.scss'],
})
export class AssetDashboardCardViewComponent {
  @Input() assets!: AssetUIModel[];

  needSliderPagination = false;

  constructor(private router: Router) {}

  assetIDToParam(assetID?: string) {
    const currentUrl = '/assets/detail/' + assetID;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }
}
